import { render } from "./Spotify.vue?vue&type=template&id=3818e43a"
import script from "./Spotify.vue?vue&type=script&lang=ts"
export * from "./Spotify.vue?vue&type=script&lang=ts"
script.render = render

export default script